import { Heading, MultiSelectCard, Text } from '@ksyos/design-system';
import type { FinancialReportType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { IColumnData } from './requestFinancialExportUtils';

interface IRequestFinancialExportMultiSelectProps {
    dataColumns: IColumnData[];
    financialReportType?: FinancialReportType;
    onSelectionChange: (columnName: string, value: string[]) => void;
    options: (columnName: string) => string[];
}

export function RequestFinancialExportMultiSelect(props: IRequestFinancialExportMultiSelectProps) {
    const language = getSelectedLanguage();

    return (
        <>
            <Heading
                marginY={3}
                size="small"
            >
                {language.common.data}
            </Heading>
            <Text marginBottom={4}>{language.finance.sensitiveDataInfoText}</Text>
            {props.dataColumns.map((column) => {
                if (column.data.length > 0) {
                    return (
                        <MultiSelectCard
                            key={column.name + (props.financialReportType || '')}
                            onSelectionChange={(value) => {
                                props.onSelectionChange(column.name, value);
                            }}
                            options={column.data}
                            selectedOptions={props.options(column.name)}
                            sx={{ marginBottom: 4 }}
                            title={column.name}
                        />
                    );
                }
            })}
        </>
    );
}
